var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommitmentWhy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Target"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M13 2V4.07031C14.76 4.29351 16.3959 5.09513 17.6504 6.34961C18.9049 7.60409 19.7065 9.23999 19.9297 11H22V13H19.9297C19.7065 14.76 18.9049 16.3959 17.6504 17.6504C16.3959 18.9049 14.76 19.7065 13 19.9297V22H11V19.9297C9.23999 19.7065 7.60409 18.9049 6.34961 17.6504C5.09513 16.3959 4.29351 14.76 4.07031 13H2V11H4.07031C4.29351 9.23999 5.09513 7.60409 6.34961 6.34961C7.60409 5.09513 9.23999 4.29351 11 4.07031V2H13ZM12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6ZM12 9C12.7956 9 13.5585 9.3163 14.1211 9.87891C14.6837 10.4415 15 11.2044 15 12C15 12.7956 14.6837 13.5585 14.1211 14.1211C13.5585 14.6837 12.7956 15 12 15C11.2044 15 10.4415 14.6837 9.87891 14.1211C9.3163 13.5585 9 12.7956 9 12C9 11.2044 9.3163 10.4415 9.87891 9.87891C10.4415 9.3163 11.2044 9 12 9Z",
    fill: "#0D70DC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitmentWhy);
export default __webpack_public_path__ + "static/media/commitment-why.ec335a150fc72ff7c426c95ad43a97be.svg";
export { ForwardRef as ReactComponent };